import { IDropdown } from '@app/shared/interfaces/dropdown';

export enum INSTRUCTION_FOLLOWING {
  'Only as a general guide' = 1,
  'Follow strictly even if my proxy thinks it is not in my best interest' = 2,
}

export const INSTRUCTION_FOLLOWING_DROPDOWN: IDropdown<string>[] = Object.values(INSTRUCTION_FOLLOWING)
  .filter((value) => isNaN(Number(value)) === true)
  .map((value) => ({ value: `${INSTRUCTION_FOLLOWING[value]}`, label: value } as IDropdown<string>));
